import { CheckCircle, CircleNotch, Warning, XCircle, PauseCircle, CloudArrowUp, MagnifyingGlass, Gear } from "@phosphor-icons/react";

const MAP = {
  uploading: { label: "Uploading", cls: "bg-accent text-accent-foreground", Icon: CloudArrowUp },
  analyzing: { label: "Analyzing", cls: "bg-accent text-accent-foreground", Icon: MagnifyingGlass },
  analyzed: { label: "Analyzed", cls: "bg-accent text-accent-foreground", Icon: MagnifyingGlass },
  preparing: { label: "Preparing", cls: "bg-accent text-accent-foreground", Icon: Gear },
  prepared: { label: "Prepared", cls: "bg-accent text-accent-foreground", Icon: Gear },
  testing: { label: "Testing", cls: "bg-accent text-accent-foreground", Icon: CircleNotch },
  ready: { label: "Ready", cls: "bg-success text-success-foreground", Icon: CheckCircle },
  deploying: { label: "Deploying", cls: "bg-accent text-accent-foreground", Icon: CircleNotch },
  live: { label: "Live", cls: "bg-success text-success-foreground", Icon: CheckCircle },
  needs_attention: { label: "Needs attention", cls: "bg-warning text-warning-foreground", Icon: Warning },
  failed: { label: "Failed", cls: "bg-destructive/10 text-destructive", Icon: XCircle },
  stopped: { label: "Stopped", cls: "bg-muted text-muted-foreground", Icon: PauseCircle },
};

export function StatusBadge({ status, className = "" }) {
  const s = MAP[status] || MAP.analyzing;
  const { Icon } = s;
  const spin = ["analyzing", "preparing", "testing", "deploying"].includes(status);
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${s.cls} ${className}`}>
      <Icon size={14} weight="bold" className={spin ? "animate-spin" : ""} />
      {s.label}
      {status === "live" && <span className="ml-0.5 h-1.5 w-1.5 rounded-full bg-success-foreground animate-pulse" />}
    </span>
  );
}
